<main class="page-introduction">

    <div class="page-jt-icon">
        <img src="assets/jtsiteimage.png" alt="JT Site Image">
    </div>

    <article class="page-intro-text">
        <div class="page-intro-container">
            <h2> Hello, I'm JT!</h2>
            <div class="advent-pro-jaytee">
                <p>
                    Over a decade working with different technologies, I am a Senior Full Stack Developer that focuses 
                    on AWS and Azure in both my professional and personal work. Currently residing in the Washington D.C / Baltimore 
                    metro area, I've worked with multiple government agencies and provide SME support to SharePoint and Azure. In my free 
                    time, I enjoy working on building websites and making web-based games. 
                    <br><br>
                    This site was written in Angular and is built as a Serverless AWS Application using CloudFormation, S3, API Gateway, Lambda, Cognito, 
                    and using CI/CD piplining.
                </p>
            </div>
        </div>
    </article>

</main>
